import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ServiceGrid from '../components/ServiceGrid';
import { BlogTilePreview } from '../components/Blog';
import { BLOG_POSTS } from '../components/Blog';

const RESIDENTIAL_SERVICES = [
  'Pressure Washing',
  'Driveway Cleaning',
  'Window Cleaning',
  'Gutter Cleaning',
  'Sidewalk Cleaning',
  'Patio Cleaning',
  'Deck Cleaning',
  'Fence Cleaning',
  'Solar Panel Cleaning',
  'Pool Deck Cleaning',
];

const Residential = () => (
  <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <SEO 
      title="Residential Pressure Washing Services | Phoenix Area"
      description="Transform your home with professional residential pressure washing in Phoenix, Scottsdale, and beyond. Expert cleaning for driveways, patios, and more. Free quotes!"
      keywords="residential pressure washing, home cleaning, Phoenix, Scottsdale, exterior cleaning, property maintenance, Copper Canyon Pressure Wash, free quote"
    />
    {/* Hero/Banner */}
    <section className="w-full h-48 sm:h-64 md:h-80 lg:h-96 mb-8 rounded-lg overflow-hidden bg-gray-200 flex items-center justify-center" aria-label="Residential Banner">
      <img 
        src="/Hero_Image.JPG" 
        alt="Residential pressure washing services" 
        className="w-full h-full object-cover object-center" 
      />
    </section>
    <div className="max-w-3xl mx-auto text-center mb-12">
      <h1 className="text-4xl font-bold text-[#4a3f35] mb-4">Residential Services</h1>
      <p className="text-lg text-gray-700 mb-4">
        Keep your home looking its best with our professional residential pressure washing and exterior cleaning services. 
        We serve homeowners throughout the Phoenix area with reliable, high-quality cleaning solutions.
      </p>
    </div>
    <section className="mb-16">
      <h2 className="text-2xl font-semibold text-[#b87c4c] mb-6 text-center">Our Residential Services</h2>
      <ServiceGrid services={RESIDENTIAL_SERVICES} />
    </section>

    {/* Blog Tile Section */}
    <section className="mt-16">
      <h2 className="text-2xl font-semibold text-[#b87c4c] mb-6 text-center">Helpful Articles</h2>
      <div className="max-w-3xl mx-auto">
        <BlogTilePreview post={BLOG_POSTS.find(post => post.slug === 'driveway-cleaning-guide')} />
      </div>
    </section>
  </main>
);

export default Residential; 